document.addEventListener('DOMContentLoaded', function(e) {
    let resumeForm = document.getElementById('resume-form');
    let toggle = document.querySelector('a[href="#resume-form"]');

    if (resumeForm && toggle) {
        toggle.addEventListener('click', function(e) {
            e.preventDefault();
            resumeForm.classList.add('open');
        })

        resumeForm.addEventListener('click', function(e) {
            if (e.target.closest('form') == null || e.target.closest('.close') != null) {
                resumeForm.classList.remove('open')
            }
        })
    }
})